import BaseInput from 'components/BaseInput';
import DefaultSelect from 'react-select';
import styled from 'styled-components';

export const Container = styled(BaseInput)``;

export const Select = styled(DefaultSelect)``;
